import usePageTitle from "@/hooks/use-page-title";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const SERVICES = [
  { title: "Flex Printing", desc: "High-quality outdoor flex banners in any size, backlit or frontlit." },
  { title: "Vinyl Printing", desc: "Adhesive vinyl for shops, offices, glass, walls & interiors." },
  { title: "One Way Vision", desc: "Perforated vinyl for windows — full print outside, clear from inside." },
  { title: "Sunboard & Foam Board", desc: "Lightweight rigid signage for indoor & event displays." },
  { title: "Acrylic Signage", desc: "Premium 3mm–10mm acrylic letters, logos, and panels." },
  { title: "ACP Sign Boards", desc: "Weatherproof aluminium composite panel signage for building fronts." },
  { title: "LED Sign Boards", desc: "Backlit and edge-lit LED signage with warranty." },
  { title: "Glow Signs", desc: "Traditional acrylic + LED glow signs for shops and showrooms." },
  { title: "Roll-Up Standees", desc: "Portable pull-up banners perfect for events and exhibitions." },
  { title: "Brochures & Flyers", desc: "Offset & digital print in art card, matte, gloss finishes." },
  { title: "Visiting Cards", desc: "Standard, premium, spot UV, foiling, embossing options." },
  { title: "Letterheads & Bill Books", desc: "Bulk stationery printing on quality paper stock." },
  { title: "Stickers & Labels", desc: "Custom-cut stickers, product labels, industrial labels." },
  { title: "Menu Cards", desc: "Restaurant menus, café boards, standees & take-aways." },
  { title: "Canvas & Photo Frames", desc: "Wall art, memory canvases, event photography frames." },
  { title: "T-Shirt & Apparel", desc: "Screen print, DTF, sublimation — corporate & event tees." },
  { title: "Mugs & Corporate Gifts", desc: "Personalized mugs, diaries, pens, ID cards, lanyards." },
  { title: "Trophies & Medals", desc: "Acrylic trophies, metal medals, engraved awards." },
  { title: "Vehicle Branding", desc: "Full & partial wraps, one-way vision, fleet branding." },
  { title: "Shop Branding & Installation", desc: "End-to-end shop signage design, print, and installation." },
];

export default function Services() {
  usePageTitle("Services");
  return (
    <div className="py-20 max-w-7xl mx-auto px-4 lg:px-8">
      <div className="text-center mb-14">
        <div className="overline mb-2">Services</div>
        <h1 className="font-display text-5xl md:text-6xl font-black tracking-tighter">Everything you need to print</h1>
        <p className="mt-4 text-zinc-600 max-w-2xl mx-auto">
          From a single visiting card to a full storefront branding — one team, one vendor, zero hassle.
        </p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map((s, i) => (
          <div key={s.title} className="p-6 rounded-2xl bg-white border border-zinc-200 hover:border-[#FF6B00] hover:shadow-xl transition-all group">
            <div className="font-mono text-xs text-[#FF6B00] mb-3">{String(i + 1).padStart(2, "0")}</div>
            <div className="font-bold text-lg mb-2 group-hover:text-[#FF6B00] transition-colors">{s.title}</div>
            <div className="text-sm text-zinc-600">{s.desc}</div>
          </div>
        ))}
      </div>
      <div className="text-center mt-14">
        <Link to="/contact" className="btn-swiss btn-accent">Request Custom Quote <ArrowRight size={14} /></Link>
      </div>
    </div>
  );
}
